import { render, staticRenderFns } from "./werlotus_detail.html?vue&type=template&id=b25d9d78&scoped=true&"
import script from "./werlotus_detail.vue?vue&type=script&lang=js&"
export * from "./werlotus_detail.vue?vue&type=script&lang=js&"
import style0 from "./werlotus_detail.scss?vue&type=style&index=0&id=b25d9d78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25d9d78",
  null
  
)

export default component.exports